/* MONORETRO V4 — the opening film, the live date stamp, WORN / OBJECT / INDEX, the bag drawer (with its review quotes) and "Earlier".
   Vanilla JS, no dependencies. Everything degrades: without JS the film shows its poster or first still,
   the grid shows Object, the bag icon goes to the cart page. */
(function () {
  'use strict';
  if (window.__npShop) return; window.__npShop = true;
  var d = document, root = d.documentElement;
  var store = {
    get: function (k, f) { try { var v = localStorage.getItem(k); return v === null ? f : JSON.parse(v); } catch (e) { return f; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- Camera date stamp: '26 10 2  21:04 ---------- */
  var camDate = function (t) { return "'" + String(t.getFullYear()).slice(2) + ' ' + (t.getMonth() + 1) + ' ' + t.getDate(); };
  var camTime = function (t) { return pad(t.getHours()) + ':' + pad(t.getMinutes()); };
  var tickStamps = function () {
    var t = new Date();
    d.querySelectorAll('[data-np-live-stamp]').forEach(function (el) { el.textContent = camDate(t) + '  ' + camTime(t); });
  };
  tickStamps(); setInterval(tickStamps, 15000);

  /* ---------- The opening film ---------- */
  d.querySelectorAll('[data-np-film]').forEach(function (film) {
    var v = film.querySelector('[data-np-video]');
    if (v) {
      var mobile = window.matchMedia('(max-width: 767px)').matches;
      var src = (mobile && v.getAttribute('data-src-m')) || v.getAttribute('data-src-d');
      var saveData = navigator.connection && navigator.connection.saveData;
      var tg = film.querySelector('[data-np-film-toggle]');
      // Not playing (reduced motion, data saver, or the phone refused autoplay, e.g. iPhone Low Power Mode):
      // the poster stays, and the button offers "Play" so a tap starts the film.
      var held = function () { if (tg) { tg.setAttribute('aria-pressed', 'true'); tg.textContent = tg.getAttribute('data-label-play'); } };
      var start = function (auto) {
        if (!v.getAttribute('src')) v.src = src;
        var p = v.play(); if (p && p.catch) p.catch(function (e) { if (!auto || (e && e.name === 'NotAllowedError')) held(); });
      };
      v.addEventListener('playing', function () { film.classList.add('is-playing'); if (tg) { tg.setAttribute('aria-pressed', 'false'); tg.textContent = tg.getAttribute('data-label-pause'); } });
      if (src && !reduce && !saveData) {
        v.autoplay = true; v.src = src;
        // Some mobile browsers refuse a play() issued before any data; try again once it can play
        v.addEventListener('canplay', function () { if (v.paused && !(tg && tg.getAttribute('aria-pressed') === 'true')) v.play().catch(function (e) { if (e && e.name === 'NotAllowedError') held(); }); }, { once: true });
        start(true);
      } else if (src) held();
      if (tg) tg.addEventListener('click', function () {
        if (v.paused) start();
        else { v.pause(); held(); }
      });
      // Pause when off screen (battery, CPU)
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (!v.src) return; if (e.isIntersecting) { if (tg && tg.getAttribute('aria-pressed') === 'true') return; v.play().catch(function () {}); } else v.pause(); });
      }, { threshold: 0.1 }).observe(film);
      return;
    }
    // Stand-in reel: stills cut with a flash, a slow push-in on each
    var reel = film.querySelector('[data-np-reel]'); if (!reel) return;
    var stills = Array.prototype.slice.call(reel.querySelectorAll('[data-still]'));
    var flash = reel.querySelector('[data-np-flash]');
    if (stills.length < 2 || reduce) return;
    var i = 0, hold = (parseFloat(film.getAttribute('data-hold')) || 2.6) * 1000, timer, visible = true;
    var next = function () {
      if (!visible) { timer = setTimeout(next, hold); return; }
      if (flash) { flash.classList.remove('is-pop'); void flash.offsetWidth; flash.classList.add('is-pop'); }
      setTimeout(function () {
        stills[i].classList.remove('is-on');
        i = (i + 1) % stills.length;
        var img = stills[i].querySelector('img'); if (img) img.loading = 'eager';
        stills[i].classList.add('is-on');
        var n = stills[(i + 1) % stills.length].querySelector('img'); if (n) n.loading = 'eager';
      }, 70);
      timer = setTimeout(next, hold);
    };
    timer = setTimeout(next, hold);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.1 }).observe(film);
  });

  /* ---------- WORN / OBJECT / INDEX ---------- */
  var setLens = function (v) {
    if (['worn', 'object', 'index'].indexOf(v) < 0) v = 'object';
    root.setAttribute('data-lens', v);
    store.set('np-lens', v);
    d.querySelectorAll('[data-lens-set]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lens-set') === v ? 'true' : 'false'); });
  };
  var lensSwitches = d.querySelectorAll('[data-lens-switch]');
  if (lensSwitches.length) {
    setLens(root.getAttribute('data-lens') || 'object');
    d.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lens-set]'); if (!b) return;
      setLens(b.getAttribute('data-lens-set'));
    });
  }

  /* ---------- EARLIER: recently looked at, stamped with the time you looked ---------- */
  // v2 (5 Oct 2026): product images were replaced; entries recorded before then point at stale cached files.
  var KEY = 'np-earlier-v2';
  try { localStorage.removeItem('np-earlier'); } catch (e) {}
  var rec = d.querySelector('[data-np-record]');
  // one entry per product: the department (&d=) and cache/preview parameters do not make a new page
  var here = location.pathname + location.search.replace(/[?&](cb|preview_theme_id|d|v)=[^&]*/g, '').replace(/^&/, '?');
  if (rec) {
    try {
      var r = JSON.parse(rec.getAttribute('data-np-record'));
      var list = store.get(KEY, []).filter(function (x) { return x.u !== here; });
      list.unshift({ u: here, n: r.n, s: r.s || '', i: r.i, t: Date.now() });
      store.set(KEY, list.slice(0, 12));
    } catch (e) {}
  }
  var stampFor = function (ts) {
    var t = new Date(ts), now = new Date();
    return t.toDateString() === now.toDateString() ? camTime(t) : camDate(t);
  };
  d.querySelectorAll('[data-np-earlier]').forEach(function (sec) {
    var items = store.get(KEY, []).filter(function (x) { return x.u !== here; }).slice(0, 6);
    if (!items.length) return;
    var ol = sec.querySelector('[data-np-earlier-list]');
    ol.innerHTML = items.map(function (x) {
      return '<li class="np-earlier__item"><a href="' + esc(x.u) + '"><span class="np-earlier__media">' +
        (x.i ? '<img src="' + esc(x.i) + (x.i.indexOf('?') > -1 ? '&' : '?') + 'width=360" alt="" loading="lazy" decoding="async">' : '') +
        '<span class="np-stamp np-earlier__stamp">' + stampFor(x.t) + '</span></span><span class="np-earlier__name">' + esc(x.n) + '</span>' +
        (x.s ? '<span class="np-earlier__spec">' + esc(x.s) + '</span>' : '') + '</a></li>';
    }).join('');
    sec.hidden = false;
  });

  /* ---------- FIRST ACCESS (pre-launch sign-ups): where the visitor came from, and analytics events ---------- */
  (function () {
    var src = '';
    try {
      src = sessionStorage.getItem('np-src') || '';
      if (!src) {
        var q = (location.search.match(/[?&]utm_source=([^&]+)/) || [])[1];
        var ref = d.referrer && d.referrer.indexOf(location.hostname) < 0 ? d.referrer.replace(/^https?:\/\/(www\.|l\.|m\.)?/, '').split('/')[0] : '';
        src = (q ? decodeURIComponent(q) : ref || 'direct').toLowerCase().replace(/[^a-z0-9.-]/g, '').slice(0, 40);
        sessionStorage.setItem('np-src', src);
      }
    } catch (e) {}
    d.querySelectorAll('[data-launch-tags]').forEach(function (inp) {
      var f = inp.form; if (!f) return;
      if (src && inp.value.indexOf('src:') < 0) inp.value += ', src:' + src;
      f.addEventListener('submit', function () {
        try { sessionStorage.setItem('np-signup', JSON.stringify({ product: inp.getAttribute('data-interest') || '', source: src })); } catch (e) {}
      });
    });
    // the page reloads after a successful sign-up: publish the event once, then forget it
    try {
      var done = sessionStorage.getItem('np-signup');
      if (done && (d.querySelector('[data-launch-ok]') || /customer_posted=true/.test(location.search) || d.querySelector('.letters__ok'))) {
        sessionStorage.removeItem('np-signup');
        var ev = JSON.parse(done);
        Shopify.analytics.publish('np_first_access_signup', ev);
        if (ev.product) Shopify.analytics.publish('np_product_interest', ev);
      }
    } catch (e) {}
    d.querySelectorAll('[data-first-access]').forEach(function (a) {
      a.addEventListener('click', function () { var em = d.querySelector('#FooterLetters input[type=email]'); if (em) setTimeout(function () { em.focus({ preventScroll: true }); }, 400); });
    });
  })();

  /* ---------- SIGN-UP CONFIRMATION: the reload after a sign-up lands at the top of the page, so say thank you where the visitor is ---------- */
  (function () {
    if (!/customer_posted=true/.test(location.search)) return;
    var card = d.querySelector('[data-np-thanks]'); if (!card) return;
    card.hidden = false;
    requestAnimationFrame(function () { card.classList.add('is-in'); });
    var close = card.querySelector('[data-np-thanks-close]');
    if (close) close.addEventListener('click', function () { card.classList.remove('is-in'); setTimeout(function () { card.hidden = true; }, 300); });
    setTimeout(function () { card.classList.remove('is-in'); setTimeout(function () { card.hidden = true; }, 300); }, 12000);
  })();

  /* ---------- FIRST ACCESS SLIDE-IN (pre-release): once per visit, never after a sign-up, 14 days after closing ---------- */
  (function () {
    var box = d.querySelector('[data-fa-slide]'); if (!box) return;
    var ls = function (k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } };
    var ss = function (k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } };
    if (/customer_posted=true/.test(location.search) || d.querySelector('[data-launch-ok]') || d.querySelector('.letters__ok')) ls('np-signed', '1');
    d.querySelectorAll('[data-launch-tags]').forEach(function (inp) { if (inp.form) inp.form.addEventListener('submit', function () { ls('np-signed', '1'); }); });
    var closed = +(ls('np-slide-closed') || 0);
    if (ls('np-signed') || ss('np-slide-shown') || Date.now() - closed < 14 * 864e5) return;
    var t0 = Date.now(), shown = false, timer;
    var show = function () {
      if (shown) return; shown = true; ss('np-slide-shown', '1'); clearTimeout(timer); window.removeEventListener('scroll', onScroll);
      box.hidden = false; requestAnimationFrame(function () { box.classList.add('is-in'); });
      try { Shopify.analytics.publish('np_slide_shown', { page: location.pathname }); } catch (e) {}
    };
    var onScroll = function () {
      var h = d.documentElement.scrollHeight - innerHeight;
      if (h > 0 && scrollY / h >= 0.5 && Date.now() - t0 > 15000) show();
    };
    timer = setTimeout(show, 45000);
    window.addEventListener('scroll', onScroll, { passive: true });
    box.querySelector('[data-fa-close]').addEventListener('click', function () {
      ls('np-slide-closed', String(Date.now())); box.classList.remove('is-in'); setTimeout(function () { box.hidden = true; }, 350);
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) box.querySelector('[data-fa-close]').click(); });
  })();

  /* ---------- Store reviews in the bag: one short quote at a time, the next every 5 s while the bag is open.
     Not with reduced motion (the first quote stays); held while the pointer or focus is on it. ---------- */
  (function () {
    var box = d.querySelector('[data-np-quotes]'); if (!box || reduce) return;
    var qs = box.querySelectorAll('[data-np-quote]'); if (qs.length < 2) return;
    var i = 0, held = false, drawer = box.closest('[data-np-bag]');
    var hold = function (on) { return function () { held = on; }; };
    box.addEventListener('mouseenter', hold(true)); box.addEventListener('mouseleave', hold(false));
    box.addEventListener('focusin', hold(true)); box.addEventListener('focusout', hold(false));
    setInterval(function () {
      if (held || (drawer && drawer.hidden) || d.hidden) return;
      qs[i].classList.remove('is-on');
      i = (i + 1) % qs.length;
      qs[i].classList.add('is-on');
    }, 5000);
  })();

  /* ---------- THE BAG ---------- */
  var bag = d.querySelector('[data-np-bag]'); if (!bag) return;
  var dev = bag.getAttribute('data-mode') === 'dev';
  var panel = bag.querySelector('.bag__panel');
  var fmt = bag.getAttribute('data-money-format') || '€{{amount_with_comma_separator}}';
  var money = function (cents) {
    var n = (cents / 100).toFixed(2);
    var withComma = n.replace('.', ',');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma).replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };
  var cat = {};
  if (dev) { try { cat = JSON.parse(bag.querySelector('[data-np-bag-cat]').textContent); } catch (e) {} }
  var el = function (sel) { return bag.querySelector(sel); };
  var lastFocus = null;
  var open = function () {
    lastFocus = d.activeElement;
    bag.hidden = false; requestAnimationFrame(function () { bag.classList.add('is-open'); });
    d.body.classList.add('bag-open'); render(); setTimeout(function () { panel.focus(); }, 30);
  };
  var close = function () {
    bag.classList.remove('is-open'); d.body.classList.remove('bag-open');
    setTimeout(function () { bag.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  bag.addEventListener('click', function (e) { if (e.target.closest('[data-np-bag-close]')) close(); });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !bag.hidden) close(); });
  d.querySelectorAll('[data-np-bag-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  window.addEventListener('np:bag-open', open);

  var setCount = function (n) {
    d.querySelectorAll('[data-bag-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-count', n); });
    el('[data-np-bag-n]').textContent = n ? '(' + n + ')' : '';
  };
  var itemHTML = function (it) {
    return '<li class="bag__item" data-key="' + esc(it.key) + '">' +
      '<a class="bag__thumb" href="' + esc(it.url) + '">' + (it.img ? '<img src="' + esc(it.img) + (it.img.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="bag__info"><a class="bag__name" href="' + esc(it.url) + '">' + esc(it.name) + '</a>' +
      '<span class="bag__meta spec">' + esc(it.meta) + '</span>' +
      '<span class="bag__qty"><button type="button" data-q="-1" aria-label="−">−</button><span>' + it.q + '</span><button type="button" data-q="1" aria-label="+">+</button>' +
      '<button type="button" class="bag__rm" data-q="rm">' + esc(bag.getAttribute('data-l-remove')) + '</button></span></div>' +
      '<span class="bag__price">' + money(it.price * it.q) + '</span></li>';
  };
  var withHTML = function (w) {
    return '<li><a class="bag__with-card" href="' + esc(w.url) + '"><span class="bag__with-img">' + (w.img ? '<img src="' + esc(w.img) + (w.img.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="bag__with-name">' + esc(w.name) + '</span><span class="spec">' + money(w.price) + '</span></a></li>';
  };
  var paint = function (items, total, withs) {
    var n = items.reduce(function (a, x) { return a + x.q; }, 0);
    setCount(n);
    el('[data-np-bag-items]').innerHTML = items.map(itemHTML).join('');
    el('[data-np-bag-empty]').hidden = items.length > 0;
    el('[data-np-bag-foot]').hidden = items.length === 0;
    el('[data-np-bag-total]').textContent = money(total);
    var free = +bag.getAttribute('data-free-from') || 0, fb = el('[data-np-bag-free]');
    if (free > 0 && items.length) {
      fb.hidden = false;
      var left = free - total;
      el('[data-np-bag-free-text]').textContent = left > 0 ? bag.getAttribute('data-l-free-left').replace('{{ amount }}', money(left)) : bag.getAttribute('data-l-free-done');
      el('[data-np-bag-free-bar]').style.width = Math.min(100, total / free * 100) + '%';
    } else fb.hidden = true;
    var ws = el('[data-np-bag-with]');
    if (withs && withs.length) { el('[data-np-bag-with-list]').innerHTML = withs.slice(0, 3).map(withHTML).join(''); ws.hidden = false; } else ws.hidden = true;
  };

  /* Development: a preview bag in the browser */
  var PKEY = 'np-bag-preview';
  var devItems = function () {
    return store.get(PKEY, []).filter(function (x) { return cat[x.id]; }).map(function (x) {
      var c = cat[x.id];
      return { key: x.id + '|' + x.c + '|' + x.s, url: c.u, img: c.img[x.c] || '', name: c.n, meta: (c.cn[x.c] || x.c) + ' · ' + x.s, price: c.p, q: x.q, id: x.id };
    });
  };
  var devWith = function (items) {
    if (!items.length) return [];
    var inBag = items.map(function (x) { return x.id; });
    var look = (cat[items[0].id] && cat[items[0].id].look) || '';
    return look.split(',').map(function (p) { var a = p.split(':'), c = cat[a[0]]; if (!c || inBag.indexOf(a[0]) > -1) return null; return { url: c.u, img: c.img[a[1]] || '', name: c.n, price: c.p }; }).filter(Boolean);
  };
  var render = function () {
    if (dev) {
      var items = devItems();
      paint(items, items.reduce(function (a, x) { return a + x.price * x.q; }, 0), devWith(items));
      return;
    }
    fetch((bag.getAttribute('data-cart-url') || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items.map(function (x) {
          return { key: x.key, url: x.url, img: x.image, name: x.product_title, meta: (x.options_with_values || []).map(function (o) { return o.value; }).join(' · '), price: x.final_price, q: x.quantity, pid: x.product_id };
        });
        paint(items, cart.total_price, null);
        if (items.length && bag.getAttribute('data-reco-url')) {
          fetch(bag.getAttribute('data-reco-url') + '.json?product_id=' + items[0].pid + '&limit=4&intent=complementary')
            .then(function (r) { return r.json(); })
            .then(function (j) {
              var inBag = items.map(function (x) { return x.pid; });
              var ws = (j.products || []).filter(function (p) { return inBag.indexOf(p.id) < 0; }).map(function (p) { return { url: p.url, img: p.featured_image, name: p.title, price: p.price }; });
              if (ws.length) paint(items, cart.total_price, ws);
            }).catch(function () {});
        }
      }).catch(function () {});
  };
  bag.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]'); if (!b) return;
    var li = b.closest('[data-key]'), key = li.getAttribute('data-key'), q = b.getAttribute('data-q');
    if (dev) {
      var a = key.split('|'), list = store.get(PKEY, []);
      list = list.map(function (x) {
        if (x.id === a[0] && x.c === a[1] && x.s === a[2]) x.q = q === 'rm' ? 0 : Math.max(0, x.q + (+q));
        return x;
      }).filter(function (x) { return x.q > 0; });
      store.set(PKEY, list); render(); return;
    }
    var cur = +li.querySelector('.bag__qty span').textContent;
    var nq = q === 'rm' ? 0 : Math.max(0, cur + (+q));
    fetch((bag.getAttribute('data-cart-url') || '/cart') + '/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: nq }) })
      .then(render).catch(render);
  });
  window.addEventListener('np:bag-add', function (e) {
    var x = e.detail || {}; if (!x.id) return;
    var list = store.get(PKEY, []), found = false;
    list.forEach(function (y) { if (y.id === x.id && y.c === x.c && y.s === x.s) { y.q += 1; found = true; } });
    if (!found) list.push({ id: x.id, c: x.c, s: x.s, q: 1 });
    store.set(PKEY, list); open();
  });
  // Initial count
  if (dev) { var n0 = devItems().reduce(function (a, x) { return a + x.q; }, 0); setCount(n0); }
})();

/* ---------- The contact sheet: a few frames awake at a time, the rest at rest ---------- */
(function () {
  'use strict';
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  d.querySelectorAll('[data-np-sheet]').forEach(function (sheet) {
    var mq = window.matchMedia('(max-width: 767px)');
    var awakeN = +sheet.getAttribute('data-awake') || 3;
    var pace = (+sheet.getAttribute('data-pace') || 4.5) * 1000;
    var paused = false, visible = true, timer = null, frames = [], tick = 0;
    var pick = function () { return Array.prototype.slice.call(sheet.querySelectorAll('[data-view="' + (mq.matches ? 'mobile' : 'desktop') + '"] [data-frame]')); };
    var wake = function (f) {
      f.classList.remove('is-dim'); f.classList.add('is-awake');
      var take = (location.search.match(/[?&]take=([bc])/) || [])[1];
      var src = (take && f.getAttribute('data-video-' + take)) || f.getAttribute('data-video');
      if (src && !reduce) {
        var v = f.querySelector('video');
        if (!v) { v = d.createElement('video'); v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.preload = 'auto'; v.src = src; v.addEventListener('playing', function () { f.classList.add('is-video'); }); f.querySelector('figure').appendChild(v); }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
    };
    var rest = function (f, dim) {
      f.classList.remove('is-awake', 'is-video');
      var v = f.querySelector('video'); if (v) v.pause();
      if (dim) f.classList.add('is-dim');
    };
    var start = function () {
      frames = pick(); if (!frames.length) return;
      // Spread the first awake frames across the sheet; two frames rest almost dark ("nearly nothing")
      frames.forEach(function (f) { rest(f, false); f.classList.remove('is-dim'); });
      if (reduce) return;
      var step = Math.max(1, Math.floor(frames.length / awakeN));
      for (var i = 0, k = 1; k <= awakeN && i < frames.length; i += step, k++) wake(frames[(i + 1) % frames.length]);
      if (frames.length > 6) { frames[frames.length - 2].classList.add('is-dim'); frames[3 % frames.length].classList.add('is-dim'); }
    };
    var change = function () {
      if (paused || !visible || reduce || !frames.length) return;
      tick++;
      var awake = frames.filter(function (f) { return f.classList.contains('is-awake'); });
      var resting = frames.filter(function (f) { return !f.classList.contains('is-awake'); });
      // One awake frame settles into a still; one resting frame wakes (sometimes after a flash, sometimes into its second memory)
      if (awake.length) rest(awake[tick % awake.length], tick % 5 === 0);
      if (resting.length) {
        var f = resting[(tick * 7) % resting.length];
        if (f.hasAttribute('data-has-alt') && tick % 2 === 0) { f.classList.add('is-flash'); setTimeout(function () { f.classList.toggle('is-alt'); f.classList.remove('is-flash'); }, 120); }
        wake(f);
      }
    };
    var takeQ = (location.search.match(/[?&]take=([bc])/) || [])[1];
    if (takeQ) { var tl = d.createElement('span'); tl.className = 'np-ph np-sheet__take'; tl.textContent = 'Take ' + takeQ.toUpperCase(); sheet.appendChild(tl); }
    start();
    mq.addEventListener && mq.addEventListener('change', start);
    timer = setInterval(change, pace);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      frames.forEach(function (f) { var v = f.querySelector('video'); if (v && f.classList.contains('is-awake')) { if (visible && !paused) v.play().catch(function () {}); else v.pause(); } });
    }, { threshold: 0.05 }).observe(sheet);
    var tg = sheet.querySelector('[data-np-sheet-toggle]');
    if (tg) tg.addEventListener('click', function () {
      paused = !paused;
      tg.setAttribute('aria-pressed', paused ? 'true' : 'false');
      tg.textContent = tg.getAttribute(paused ? 'data-label-play' : 'data-label-pause');
      frames.forEach(function (f) { var v = f.querySelector('video'); if (v) { if (paused) v.pause(); else if (f.classList.contains('is-awake')) v.play().catch(function () {}); } });
      sheet.classList.toggle('is-paused', paused);
    });
  });
})();
